import Flex from 'components/Flex'
import styled from 'styled-components'
import { COLORS } from 'theme'

export const SingleCard = styled(Flex)`
  background: ${props => (props.background ? '#F6F6F6' : '#FFFFFF')};
  padding: ${props => (props.padding ? props.padding : 0)};
  border-radius: 10px;
  border: 1px solid ${props => (props.borderColor ? '#BFBFBF' : '#3249D7')};
  min-width: 12em;
  width: ${props => props.width};
  height: ${props => (props.height ? props.height : 'auto')};
  cursor: pointer;
  transition: 0.5s;
  :hover {
    ${'' /* background-color: ${COLORS.BLUE_T_80}; */}
  }
  justify-content: space-around;
`

export const CardText = styled.p`
  margin-top: 10px;
  margin-bottom: 4px;
  font-style: normal;
  font-family: 'Plus Jakarta Sans';
  font-weight: 300;
  font-size: 16px;
  line-height: 20px;
  color: ${props => props.textColor || (props.isSelected ? '#000000' : '#434343')};
`
export const CardValue = styled.p`
  margin: 0;
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  color: ${props => props.textColor || (props.isSelected ? COLORS.GREY_T_20 : '#3249D7')};
`
export const CardValueLight = styled.p`

  margin: 0;
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 19px;
  color: ${props => props.textColor || (props.isSelected ? COLORS.GREY_T_20 : '#3249D7')};
`
export const CardValueBig = styled.p`
  margin: 0;
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  line-height: 29px;
  color: ${props => props.textColor || (props.isSelected ? COLORS.GREY_T_20 : '#3249D7')};
`
export const IconTextContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const TextWrapper = styled.div`
  font-weight: normal;
  font-size: 16px;
`
